import { ref } from 'vue';

export function useForcePasswordReset() {
 const isLoading = ref(false);

 const forcePasswordReset = async (user) => {
   isLoading.value = true;

   try {
     await axios.post(`/api/users/${user.id}/force-password-reset`);
     window.emitter.emit('alertSuccess', {
       message: `User account is force to password reset successfully`,
       alertType: 'success',
       timer: 3
     });
     return true;
   } catch (error) {
    // Handle SystemException
    const errorMessage = error.response?.data?.error || 
                        error.response?.data?.message ||
                        'Operation failed';

     window.emitter.emit('alertSuccess', {
       message: errorMessage,
       alertType: 'danger', 
       timer: 10
     });

     return false;
   } finally {
     isLoading.value = false;
   }
 };

 const canManage = (currentUser) => {
   return {
    can: ['super_admin'].includes(currentUser.role.name)
   };
 };

 return {
   isLoading,
   forcePasswordReset,
   canManage
 };
}